import { AnalyticsEvent } from '../models';

export class LoginCompleteEvent implements AnalyticsEvent {
  name = 'LoginCompleteEvent';
}
